const features = [
  { icon: 'ri-focus-3-line', text: 'Detail-focused workmanship on every surface' },
  { icon: 'ri-broom-line', text: 'Clean, organized job sites throughout the project' },
  { icon: 'ri-message-2-line', text: 'Consistent communication from start to finish' },
  { icon: 'ri-award-line', text: 'Professional-grade materials and premium coatings' },
  { icon: 'ri-calendar-check-line', text: 'Reliable project timelines that we actually meet' },
  { icon: 'ri-shield-check-line', text: 'Fully insured crews you can trust in your home' },
];

export default function SharedWhyUs() {
  return (
    <section className="bg-warm-cream py-24">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16 items-center">
          {/* Left */}
          <div className="lg:col-span-2">
            <span className="font-sans text-charcoal-500 text-xs tracking-[0.3em] uppercase">The Difference</span>
            <h2 className="font-serif text-charcoal-900 text-4xl md:text-5xl mt-3 mb-4 leading-tight">
              Why Choose<br />Hometown Painters
            </h2>
            <div className="w-20 h-0.5 bg-gold mb-6" />
            <p className="font-sans text-charcoal-600 text-base leading-relaxed mb-8">
              We bring premium contractor standards to every Illinois project — whether it&apos;s a single room refresh or a full commercial repaint. Precision and professionalism, every time.
            </p>
            <a
              href="tel:8478701600"
              className="inline-flex items-center gap-2 bg-charcoal-900 text-warm-white font-sans text-sm px-7 py-3.5 rounded-full hover:bg-charcoal-700 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line text-gold" style={{ fontSize: '14px' }} />
              </div>
              Call (847) 870-1600
            </a>
          </div>

          {/* Right — features grid */}
          <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {features.map((f) => (
              <div
                key={f.text}
                className="flex items-start gap-4 bg-white rounded-xl p-5 border border-charcoal-100 hover:border-gold/30 transition-colors duration-200"
              >
                <div className="w-9 h-9 flex items-center justify-center bg-gold/10 rounded-full shrink-0 mt-0.5">
                  <i className={`${f.icon} text-gold`} style={{ fontSize: '16px' }} />
                </div>
                <span className="font-sans text-charcoal-700 text-sm leading-relaxed">{f.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
